import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get, MICROSERVICES } from 'api';
import { IRemunerationBonus } from 'interfaces/RemunerationBonus';
import {
  IMyKnownError,
  REQUEST_LIFE_CICLE,
  IPaginatedListResponse,
  IListRequestParams,
} from 'interfaces/requests';

import endpoints from './endpoints';
import { IRemunerationBonusListState } from './interfaces';

export const listRemunerationBonusAction = createAsyncThunk<
  IPaginatedListResponse<IRemunerationBonus>,
  IListRequestParams,
  { rejectValue: IMyKnownError }
>('listRemunerationBonus/fetch', async (payload, { rejectWithValue }) => {
  try {
    const result = await get<IPaginatedListResponse<IRemunerationBonus>>(
      MICROSERVICES.STRATEGIES,
      {
        url: endpoints.listRemunerationsBonus(),
        params: payload,
      },
    );
    return {
      count: result.data.count,
      values: result.data.values.map((value) => ({ ...value, id: value._id })),
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

const initialState: IRemunerationBonusListState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  errorMessage: '',
  list: [],
  count: 0,
};

const remunerationBonusListSlice = createSlice({
  name: 'remunerationBonusList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listRemunerationBonusAction.fulfilled, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      state.errorMessage = '';
      state.list = action.payload.values;
      state.count = action.payload.count;
      return state;
    });
    builder.addCase(listRemunerationBonusAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
    builder.addCase(listRemunerationBonusAction.rejected, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
      state.errorMessage = action.payload?.message || '';
      return state;
    });
  },
});

const { reducer } = remunerationBonusListSlice;
export default reducer;
